import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AiConsentService } from 'src/app/services/AIReports/ai-consent.service';

@Component({
  selector: 'app-consent-gate',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './consent-gate.component.html',
  styleUrl: './consent-gate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentGateComponent {
  protected readonly consent = inject(AiConsentService);

  readonly checked = signal(false);
  readonly accepting = signal(false);
  readonly acceptError = signal(false);

  retry(): void {
    this.consent.fetchStatus();
  }

  onCheckboxChange(event: Event): void {
    this.checked.set((event.target as HTMLInputElement).checked);
  }

  onAccept(): void {
    if (!this.checked() || this.accepting()) return;
    this.accepting.set(true);
    this.acceptError.set(false);
    this.consent.accept().subscribe({
      next: () => { this.accepting.set(false); },
      error: () => { this.accepting.set(false); this.acceptError.set(true); },
    });
  }
}
